import { TYPES } from "./types";
import { tkt1RegisteredEtsyShopService } from "../services"; 

export const getTKT1RegisteredEtsyShops = (query) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.getRegisteredEtsyShops(query);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOPS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const searchTKT1RegisteredEtsyShops = (searchQuery) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.searchRegisteredEtsyShops(searchQuery);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_SEARCH_TKT1_REGISTERED_ETSY_SHOPS_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1RegisteredEtsyShopByID = (id) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.getRegisteredEtsyShopByID(id);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_ID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const getTKT1RegisteredEtsyShopByMID = (mid) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.getRegisteredEtsyShopByMID(mid);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_TKT1_REGISTERED_ETSY_SHOP_BY_MID_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const createTKT1RegisteredEtsyShop = (shopData) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.createRegisteredEtsyShop(shopData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_CREATE_TKT1_REGISTERED_ETSY_SHOP_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const updateTKT1RegisteredEtsyShop = (id, shopData) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.updateRegisteredEtsyShop(id, shopData);
    const data = result.data.data;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS,
        payload: {data},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_UPDATE_TKT1_REGISTERED_ETSY_SHOP_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const deleteTKT1RegisteredEtsyShop = (id) => async (dispatch) => {
  try {
    const result = await tkt1RegisteredEtsyShopService.deleteRegisteredEtsyShop(id);
    
    if (result.data.success) {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_SUCCESS,
        payload: {id},
      });
    } else {
      dispatch({
        type: TYPES.ACTION_DELETE_TKT1_REGISTERED_ETSY_SHOP_FAIL,
        payload: {},
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

export const tkt1RegisteredEtsyShopAction = {
  getTKT1RegisteredEtsyShops,
  searchTKT1RegisteredEtsyShops,
  getTKT1RegisteredEtsyShopByID,
  getTKT1RegisteredEtsyShopByMID,
  createTKT1RegisteredEtsyShop,
  updateTKT1RegisteredEtsyShop,
  deleteTKT1RegisteredEtsyShop
};

export default tkt1RegisteredEtsyShopAction;
